<template>
    <main>
        <Header msg="Ressource Forecast" />
        <router-link to="/home" class="go-back">
            <svg xmlns="http://www.w3.org/2000/svg">
                <path d="m1 0 5 5L11 0" stroke="#0F2D4F" fill="none"/>
            </svg>
            Go back
        </router-link>
        <Heatmap />
    </main>
</template>
<script>
import Header from '@/components/Header.vue'
import Heatmap from '@/components/Heatmap.vue'
import useState from '@/use/useState'
import { useRouter } from "vue-router";


export default {
    name: 'HeatmapView',
    setup(){
        const state = useState()
        const router = useRouter();

        if(!state.value.loggedIn) {
        router.push('/')
        }
    },
    components: { Heatmap, Header },
}
</script>